import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onSubmit"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useForm } from "react-hook-form";
import { useState, useCallback } from "react";
import { SearchInputField } from "./Parts/index";
import classnames from "classnames";

var IconSearch = function IconSearch(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.32",
      strokeMiterlimit: "10",
      cx: "7.75",
      cy: "7.75",
      r: "7"
    }), /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.32",
      strokeMiterlimit: "10",
      d: "M19.463 19.463 12.7 12.7"
    })]
  }));
};

IconSearch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
};
import styles from "@/styles/Form.module.scss";
import { useDeviceInfoQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelSearchFormSp(_ref) {
  var onSubmit = _ref.onSubmit,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useDeviceInfoQuery.data;

  var deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  var handleKeyDown = useCallback(function (e) {
    // Return
    if (e.key === "Enter" && deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMobile) {
      setTimeout(function () {
        e.target.blur();
      }, 200);
    }
  }, [deviceInfo]);
  var handleFocus = useCallback(function () {
    setFocus(true);
  }, []);
  var handleBlur = useCallback(function () {
    setFocus(false);
  }, []);
  return /*#__PURE__*/_jsxs("form", {
    action: "#",
    onSubmit: handleSubmit(onSubmit),
    className: styles.channelSearchFormSp,
    noValidate: true,
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      className: styles.showChannelSearchFormBtn,
      children: /*#__PURE__*/_jsx(IconSearch, {})
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.channelSearchFormSpInner, _defineProperty({}, styles.focused, focus)),
      children: /*#__PURE__*/_jsx(SearchInputField, _objectSpread({
        ref: register,
        name: "search",
        placeholder: "\u5546\u54C1\u5185\u691C\u7D22",
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        onBlur: handleBlur
      }, props))
    })]
  });
}